import { App } from "vue";
import PrimeVue, { PrimeVueConfiguration } from "primevue/config";

export function applyDesignSystem<T>(app: App<T>) {
  return app.use(PrimeVue, { unstyled: true } satisfies PrimeVueConfiguration);
}
